import { Avatar } from 'antd';
import React from 'react';
const HighlightedContent = ({
  title,
  content,
  image,
  styles
}) => {
  return <div className="highlighted-container" style={styles} data-sentry-component="HighlightedContent" data-sentry-source-file="HighlightedContent.jsx">
      {image && <div className="left-side">{image}</div>}
      <div className="right-side">
        <div className="header">
          <div className="title">{title}</div>
        </div>
        <div className='content'>{content}</div>
      </div>
    </div>;
};
export default HighlightedContent;
HighlightedContent.defaultProps = {
  styles: {
    backgroundColor: '##1185b8',
    color: '#fff'
  },
  image: <img src='/assets/target-icon.png' alt='target' width={60} />
};